import { keyBy, map } from 'lodash';
export const EMAIL_RECEIVED = {
    name: 'Email Received',
    value: 'EMAIL_RECEIVED',
};
export const EMAIL_SENT = {
    name: 'Email Sent',
    value: 'EMAIL_SENT',
};
export const RECEIVED_CALL = {
    name: 'Received Call',
    value: 'RECEIVED_CALL',
};
export const CALLED = {
    name: 'Called',
    value: 'CALLED',
};
export const RECEIVED_VISIT = {
    name: 'Received Visit',
    value: 'RECEIVED_VISIT',
};
export const VISIT = {
    name: 'Visited',
    value: 'VISIT',
};
export const DOCUMENT_SENT = {
    name: 'Document Sent',
    value: 'DOCUMENT_SENT',
};
export const DOCUMENT_RECEIVED = {
    name: 'Document Received',
    value: 'DOCUMENT_RECEIVED',
};
const Basic = [
    EMAIL_RECEIVED,
    EMAIL_SENT,
    RECEIVED_CALL,
    CALLED,
    RECEIVED_VISIT,
    VISIT,
    DOCUMENT_SENT,
    DOCUMENT_RECEIVED,
];
const BasicByValue = keyBy(Basic, 'value');
const DefaultValue = map(Basic, 'value');
export default {
    Basic,
    BasicByValue,
    DefaultValue,
};
